import styled from "styled-components";

import { BlogSliderContainer } from "../blog_slider/blog_slider.style";

export const BlogHeroContainer = styled(BlogSliderContainer)`
     width:min(110rem , 95%);
     margin: 7rem auto;
`